"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react');


/* The pinned pill sits this far below the timeline's top edge and is this
 * tall (see .conversation-box--day-pill). */
const PILL_TOP = 12
const PILL_HEIGHT = 24
const PILL_GAP = 4







/*
 * The date row whose day to pin at the top of the timeline: the latest one that has
 * scrolled up under the pinned pill. Null while the first date row is still in
 * view (nothing to pin yet), and while the next date row passes under the pill,
 * so the two never overlap. It behaves like `position: sticky` on each date
 * row, which the reversed, newest-first thread can't use: its stuck pills
 * would stack with the oldest day on top.
 */
 const pickCurrentDay = (markers, containerTop) => {
  const pinTop = containerTop + PILL_TOP
  let current = null
  let next = null
  for (const marker of markers) {
    if (marker.top < pinTop) {
      if (!current || marker.top > current.top) current = marker
    } else if (!next || marker.top < next.top) {
      next = marker
    }
  }
  if (!current) return null
  if (next && next.top < pinTop + PILL_HEIGHT + PILL_GAP) return null
  return current
}; exports.pickCurrentDay = pickCurrentDay

const DAY_PILL_SELECTOR = '.date-message--content'
// Hides the in-thread pill of the pinned day, as `position: sticky` would.
const PINNED_CLASS = 'date-message--content---pinned'

/*
 * Tracks the day to pin over a scrolling thread. It reads the date rows'
 * positions on scroll (once per frame) and when the rows change, and
 * re-renders only when the pinned day itself changes.
 */
const useCurrentDayPill = (
  containerRef,
  messagesCount,
) => {
  const [day, setDay] = _react.useState(null)
  const frame = _react.useRef(null)

  const measure = _react.useCallback.call(void 0, () => {
    frame.current = null
    const container = containerRef.current
    if (!container) return
    const markers = Array.from(container.querySelectorAll(DAY_PILL_SELECTOR))
      .map(el => ({ el, top: el.getBoundingClientRect().top, text: _nullishCoalesce(_optionalChain([el, 'access', _ => _.textContent, 'optionalAccess', _2 => _2.trim, 'call', _3 => _3()]), () => ( '')) }))
    const current = exports.pickCurrentDay.call(void 0, markers, container.getBoundingClientRect().top)
    for (const { el } of markers) el.classList.toggle(PINNED_CLASS, el === _optionalChain([current, 'optionalAccess', _4 => _4.el]))
    setDay(_nullishCoalesce(_optionalChain([current, 'optionalAccess', _5 => _5.text]), () => ( null)))
  }, [containerRef])

  const schedule = _react.useCallback.call(void 0, () => {
    if (frame.current === null) frame.current = requestAnimationFrame(measure)
  }, [measure])

  _react.useLayoutEffect.call(void 0, measure, [measure, messagesCount])

  _react.useEffect.call(void 0, () => {
    const container = containerRef.current
    if (!container) return
    container.addEventListener('scroll', schedule, { passive: true })
    window.addEventListener('resize', schedule)
    return () => {
      container.removeEventListener('scroll', schedule)
      window.removeEventListener('resize', schedule)
      if (frame.current !== null) cancelAnimationFrame(frame.current)
      frame.current = null
    }
  }, [containerRef, schedule])

  return day
}

exports. default = useCurrentDayPill
